
var PhoneNumberFormatter = Class.create({
  	initialize: function() {

    },
	formatFinalNumber: function(s) {
        var s2 = (""+s).replace(/\D/g, '');
        var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
        return (!m) ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
    },
    format: function(value) {
        var formatNumber = value
        .match(/\d*/g).join('')
        .match(/(\d{0,3})(\d{0,3})(\d{0,4})/).slice(1).join('-')
        .replace(/-*$/g, '');

        return formatNumber;
    }
});

export let phoneNumberFormatter = new PhoneNumberFormatter();


// WEBPACK FOOTER //
// app/helpers/General/PhoneNunberFormatter.js